import { render } from "./PaymentTransactionCompleted.vue?vue&type=template&id=383c2e1e&scoped=true"
import script from "./PaymentTransactionCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionCompleted.vue?vue&type=script&lang=js"

import "./PaymentTransactionCompleted.vue?vue&type=style&index=0&id=383c2e1e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383c2e1e"]])

export default __exports__